import {
  Box, Grid,
} from '@material-ui/core';
import * as React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import type { AxiosError } from 'axios';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import useSWR from 'swr';
import RepairResults from './RepairResults';
import type { IRepairResult } from './RepairLookupInterfaces';

const useStyles = makeStyles(() => createStyles({
  root: {
    flexGrow: 1,
  },
}));

const WayfinderBin: React.FC = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  // const [resultSet, setResultSet] = React.useState <Array<IRepairResult> | null>(null);
  const [loading, setLoading] = React.useState<boolean>(false);

  const filterSet = {
    repairType: { repairTypeName: '', repairTypeValue: 0 },
    repairBarcode: '',
    storeRepairNumber: '',
    company: { companyId: '', companyName: '' },
    store: { storeId: '', storeName: '' },
    location: 'Wayfinder Bin',
    startDate: '2022-01-01T06:00:00.000Z',
    endDate: new Date(),
  };

  const filterSetTwo = {
    repairType: { repairTypeName: '', repairTypeValue: 0 },
    repairBarcode: '',
    storeRepairNumber: '',
    company: { companyId: '', companyName: '' },
    store: { storeId: '', storeName: '' },
    location: 'Courier - Wayfinder Bin',
    startDate: '2022-01-01T06:00:00.000Z',
    endDate: new Date(),
  };

  const fetcher = () => {
    setLoading(true);
    const result = axios.post<Array<IRepairResult>>('/repairlookup/repairlookup', filterSet)
      .then((response) => {
        setLoading(false);
        return response.data;
      })
      .catch((error: AxiosError) => {
        enqueueSnackbar(error?.response?.data, { persist: false, variant: 'error' });
        setLoading(false);
      });
    return result;
  };

  const fetcherTwo = () => {
    setLoading(true);
    const result = axios.post<Array<IRepairResult>>('/repairlookup/repairlookup', filterSetTwo)
      .then((response) => {
        setLoading(false);
        return response.data;
      })
      .catch((error: AxiosError) => {
        enqueueSnackbar(error?.response?.data, { persist: false, variant: 'error' });
        setLoading(false);
      });
    return result;
  };

  const { data: resultOne } = useSWR('/repairlookup/repairlookup', fetcher);
  const { data: resultTwo } = useSWR('/repairlookup/repairlookup/two', fetcherTwo);

  // typescript is mad when these are nullable and can't spread them so i have to null check
  // and spread on a ternary
  const resultOneWorkaround = resultOne ? [...resultOne] : [];
  const resultTwoWorkaround = resultTwo ? [...resultTwo] : [];

  return (
    <Box className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={1} />
        <Grid item xs={9} container spacing={3}>
          <Grid item xs={12}>
            <RepairResults
              loading={loading}
              resultSet={[...resultOneWorkaround, ...resultTwoWorkaround] || []}
              gridTitle="Repairs at Wayfinder Bin"
            />
          </Grid>
        </Grid>
        <Grid item xs={2} />
      </Grid>
    </Box>
  );
};
export default WayfinderBin;
